import { lendingApiFetchJson } from './lendingApiFetch';
import { createState } from '../Buyer/utils/customerState';
import logger from '../utils/logger';

export async function createBuyerAccount(
  state: ReturnType<typeof createState>,
) {
  const response = await lendingApiFetchJson('/api/lending/edge/state/', {
    method: 'post',
    body: JSON.stringify({ data: state }),
  });
  if (!response.ok) {
    logger.error('Failed to create buyer', {
      statusCode: response.status,
    });
    throw new Error(
      `POST to state API failed ${response.status} ${response.statusText}`,
    );
  }
  return await response.json();
}
